/* Episode Silver — product page behaviour
   Loaded by sections/product-template.liquid.

   Three independent pieces, each a no-op when its markup is absent:
     1. Slider arrows wired to the existing Flickity instance
     2. Lightbox corrections
     3. Personalisation rows

   No Liquid, no per-product ids. Everything is found by data attribute, so this
   file is static and cacheable.
*/
(function () {
  'use strict';

  /* The options app injects its engraving fields at the foot of the form, and
     they are moved from there into the engraving row above the buy buttons. The
     app takes several seconds, and while it sat at the foot of the form it was
     six hundred pixels of layout that appeared and then vanished again — the buy
     button visibly jumping twice. This class keeps that container out of the
     layout until it has been put where it belongs, and is lifted the moment it
     is moved, or if the app never turns up at all, so nothing can be left
     permanently hidden by it. */
  document.documentElement.classList.add('ep-io-hide');

  function epShowOptions() {
    document.documentElement.classList.remove('ep-io-hide');
  }

  /* ------------------------------------------------ 1. Slider side navigation */

  function initSideNav() {
    var nav = document.querySelector('[data-episode-sidenav]');
    if (!nav || nav.__epPlaced) { return; }

    var slideshow = document.querySelector('.product-slideshow');
    var frame = document.querySelector('.product__main-photos');

    if (!slideshow || !frame || slideshow.querySelectorAll('.product-main-slide').length < 2) {
      if (nav.parentNode) { nav.parentNode.removeChild(nav); }
      return;
    }

    frame.appendChild(nav);
    nav.removeAttribute('hidden');
    nav.__epPlaced = true;

    /* The stylesheet hides Flickity's page dots, because these arrows replace
       them. It only does so once this class is on, so that a product where the
       arrows cannot be placed keeps the dots rather than ending up with no
       image navigation at all. */
    frame.classList.add('product__main-photos--has-nav');

    function move(forward) {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var instance = window.Flickity.data(slideshow);
        if (instance) {
          if (forward) { instance.next(true); } else { instance.previous(true); }
          return;
        }
      }
      if (window.jQuery && window.jQuery(slideshow).flickity) {
        window.jQuery(slideshow).flickity(forward ? 'next' : 'previous', true);
      }
    }

    var prev = nav.querySelector('.product-side-nav__btn--prev');
    var next = nav.querySelector('.product-side-nav__btn--next');
    if (prev) { prev.addEventListener('click', function () { move(false); }); }
    if (next) { next.addEventListener('click', function () { move(true); }); }
  }

  /* ------------------------------------------------------------- 2. Lightbox */

  function patchPhotoSwipe() {
    function wrap(Original) {
      if (typeof Original !== 'function' || Original.__episodeLightbox) { return Original; }

      var Patched = function (el, ui, items, options) {
        options = options || {};

        /* Open as a fade rather than a zoom from the thumbnail. The thumbnail
           bounds are the square frame, not the letterboxed photo inside it, so a
           zoom-from-thumb animation starts from the wrong rectangle. */
        options.showHideOpacity = true;
        options.getThumbBoundsFn = false;
        options.showAnimationDuration = 300;
        options.hideAnimationDuration = 250;

        /* The actual cause of the lightbox opening far too zoomed in.

           The theme opens PhotoSwipe with scaleMode 'zoom' and initialZoomLevel
           0.5, which means "show the photo at half its natural pixel size" and
           ignores the screen entirely. Measured on this store: a 2000px master
           opens at 1000 CSS pixels tall on every device. On a desktop that is a
           little taller than the window, so the photo is cropped top and bottom
           and it reads as slightly off. On a phone about 390 CSS pixels wide it
           is roughly two and a half times the screen, which is the report.

           It also got worse rather than better when the set images were replaced
           with 2000 by 2000 masters, because the overscale is a fraction of the
           file's own size. That is why it looked like a regression.

           scaleMode 'fit' makes PhotoSwipe use its own fitRatio, which it already
           computes correctly from the live viewport. Verified: fitRatio 0.45,
           initialZoomLevel 0.45, photo exactly inside the window with nothing
           cropped. Nothing else about zooming is touched. maxSpreadZoom and the
           double tap step are left at the theme's values, because every attempt to
           correct those from out here produced a different wrong answer on a phone
           than on a desktop. */
        options.scaleMode = 'fit';
        return new Original(el, ui, items, options);
      };

      Patched.prototype = Original.prototype;
      Patched.__episodeLightbox = true;
      return Patched;
    }

    /* The library may already be present, or may be loaded on the first zoom. A
       property hook covers both orders without polling. */
    var current = window.PhotoSwipe;
    try {
      Object.defineProperty(window, 'PhotoSwipe', {
        configurable: true,
        get: function () { return current; },
        set: function (value) { current = wrap(value); }
      });
      if (current) { current = wrap(current); }
    } catch (e) {
      if (current) { window.PhotoSwipe = wrap(current); }
    }
  }

  function initTapToZoom() {
    /* The theme already opens the lightbox from an image tap in some contexts, so
       firing the magnifier unconditionally opens and immediately closes it. This
       waits to see whether the lightbox appeared on its own and only steps in when
       it did not. A drag is never treated as a tap, so swiping still works. */
    var startX = 0;
    var startY = 0;

    document.addEventListener('pointerdown', function (event) {
      if (!event.target.closest) { return; }
      if (!event.target.closest('.product-main-slide .image-wrap')) { return; }
      startX = event.clientX;
      startY = event.clientY;
    }, true);

    document.addEventListener('pointerup', function (event) {
      if (!event.target.closest) { return; }

      var wrapEl = event.target.closest('.product-main-slide .image-wrap');
      if (!wrapEl) { return; }
      if (event.target.closest('button, a')) { return; }
      if (Math.abs(event.clientX - startX) > 10 || Math.abs(event.clientY - startY) > 10) { return; }

      var slide = wrapEl.closest('.product-main-slide');
      var zoom = slide && slide.querySelector('.js-photoswipe__zoom');
      if (!zoom) { return; }

      window.setTimeout(function () {
        if (document.querySelector('.pswp--open')) { return; }
        zoom.click();
      }, 180);
    }, true);
  }

  /* --------------------------------------------------- 3. Personalisation rows */

  function initPersonalisation() {
    var block = document.querySelector('[data-episode-pers]');
    if (!block || block.__epPlaced) { return; }
    block.__epPlaced = true;

    var form = document.querySelector('form.product-single__form');
    if (!form) {
      if (block.parentNode) { block.parentNode.removeChild(block); }
      return;
    }

    /* Sit directly above the buy buttons, inside the form so the fields post. */
    var anchor = form.querySelector('.payment-buttons') || form.querySelector('.product__quantity');
    if (anchor) { form.insertBefore(block, anchor); } else { form.appendChild(block); }
    block.removeAttribute('hidden');

    var row = block.querySelector('[data-pers-engraving-row]');
    var slot = block.querySelector('[data-pers-engraving-slot]');

    /* Some products already carry a Message field from the app. Where that is the
       case, move it into the gift message row and drop our textarea, so a shopper
       never sees two boxes asking for the same thing. */
    function adoptAppMessage(io) {
      var appMessage = io.querySelector('[name="properties[Message]"]');
      if (!appMessage) { return; }

      var group = appMessage;
      while (group.parentNode && group.parentNode !== io) { group = group.parentNode; }
      if (group.parentNode !== io) { return; }

      var rows = block.querySelectorAll('.pers__row');
      var msgBody = rows.length ? rows[rows.length - 1].querySelector('.pers__body') : null;
      if (!msgBody) { return; }

      var mine = msgBody.querySelector('.pers__textarea');
      var counter = msgBody.querySelector('[data-pers-count]');
      if (mine) { mine.parentNode.removeChild(mine); }
      if (counter) { counter.parentNode.removeChild(counter); }
      msgBody.appendChild(group);
    }

    /* The app injects late and on its own schedule, so watch for it. Ten seconds
       was not long enough: on a slow connection it has been seen arriving at
       fifteen, by which point this had given up, taken the engraving row away
       and let the app's own container appear unstyled at the foot of the form.
       Thirty seconds, and an observer so it is caught the moment it lands rather
       than up to a quarter second later. */
    var tries = 0;
    var ioObserver = null;

    function grabOptions() {
      var io = document.getElementById('infiniteoptions-container');
      if (!io) { return false; }
      if (slot && !slot.contains(io)) { slot.appendChild(io); }
      io.style.display = '';
      adoptAppMessage(io);
      epShowOptions();
      if (ioObserver) { ioObserver.disconnect(); ioObserver = null; }
      return true;
    }

    if (window.MutationObserver) {
      ioObserver = new MutationObserver(function () { grabOptions(); });
      ioObserver.observe(document.body, { childList: true, subtree: true });
    }

    (function grab() {
      if (grabOptions()) { return; }
      if (++tries > 120) {
        if (row && row.parentNode) { row.parentNode.removeChild(row); }
        epShowOptions();
        if (ioObserver) { ioObserver.disconnect(); ioObserver = null; }
        return;
      }
      window.setTimeout(grab, 250);
    })();

    /* Character counter, and drop the property when blank so the order does not
       carry an empty line. */
    var textarea = block.querySelector('.pers__textarea');
    var count = block.querySelector('[data-pers-count]');
    if (textarea) {
      var max = textarea.getAttribute('maxlength');
      var sync = function () {
        if (count) { count.textContent = textarea.value.length + ' / ' + max; }
      };
      textarea.addEventListener('input', sync);
      sync();
      form.addEventListener('submit', function () {
        if (!textarea.value.trim()) { textarea.disabled = true; }
      });
    }
  }

  /* ---------------------------------------- 5. Description, See more control

     The wrapper and the clamp are printed by the server and set in the
     stylesheet, so the description is already in the right place and the right
     height before the browser paints. All that is left here is the control:
     whether one is needed at all, and what happens when it is used. */

  function initDescription() {
    var wrap = document.querySelector('.ep-desc');
    if (!wrap || wrap.__epReady) { return; }

    var body = wrap.querySelector('.ep-desc__body');
    var desc = wrap.querySelector('.product-single__description');
    if (!body || !desc) { return; }
    wrap.__epReady = true;

    /* The fade at the cut needs to match whatever is actually behind the
       column, so read it rather than assuming white. */
    var node = wrap;
    var fade = '';
    while (node && node !== document.documentElement) {
      var bg = window.getComputedStyle(node).backgroundColor;
      if (bg && bg !== 'transparent' && bg.indexOf('rgba(0, 0, 0, 0)') === -1) { fade = bg; break; }
      node = node.parentNode;
    }
    wrap.style.setProperty('--ep-desc-fade', fade || '#ffffff');

    var toggle = wrap.querySelector('.ep-desc__toggle');
    if (!toggle) { return; }

    var open = false;
    var collapsed = 0;

    function measure() {
      /* The clamp itself comes from the stylesheet, so read back what it
         resolved to rather than recomputing it from the line height. */
      collapsed = Math.round(parseFloat(window.getComputedStyle(body).maxHeight)) || 0;
      if (!collapsed) { collapsed = Math.round((parseFloat(window.getComputedStyle(desc).fontSize) || 15) * 7.4); }

      /* Only offer the control when there is genuinely something hidden. A
         two line description should just sit there uncut. */
      var overflows = body.scrollHeight > collapsed + 4;

      if (!overflows) {
        open = false;
        wrap.classList.remove('ep-desc--clamped');
        body.style.maxHeight = '';
        toggle.hidden = true;
        return;
      }

      toggle.hidden = false;
      if (!open) {
        wrap.classList.add('ep-desc--clamped');
        body.style.maxHeight = collapsed + 'px';
      }
    }

    toggle.addEventListener('click', function () {
      open = !open;
      wrap.classList.toggle('ep-desc--clamped', !open);
      wrap.classList.toggle('ep-desc--open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('.ep-desc__toggle-text').textContent = open ? 'See less' : 'See more';

      if (open) {
        body.style.maxHeight = body.scrollHeight + 'px';
        window.setTimeout(function () { if (open) { body.style.maxHeight = 'none'; } }, 320);
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        /* Force a reflow so the browser has a height to animate away from. */
        void body.offsetHeight;
        body.style.maxHeight = collapsed + 'px';
        var top = wrap.getBoundingClientRect().top;
        if (top < 0) { window.scrollBy(0, top - 24); }
      }
    });

    measure();

    /* Images and webfonts land after first paint and change the height, so take
       a second reading once everything has settled. */
    window.addEventListener('load', function () { if (!open) { measure(); } });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { if (!open) { measure(); } });
      ro.observe(desc);
    }
  }

  /* ------------------------------------------------------ 7. Sticky buy bar

     Deliberately absent at the top of the page. At rest the shopper is reading
     the photograph, the name and the price, and a bar pinned over the bottom of
     the screen there covers the price and buys nothing. It arrives once they
     have scrolled past the first screen, leaves again while the real buy area
     is on screen so there are never two Add to carts competing, and leaves at
     the foot of the page.

     Both actions are carried. Neither is reimplemented: Add to cart clicks the
     theme's own button and Buy it now clicks Shopify's own dynamic checkout
     button, so variant validation, the engraving and gift message fields, the
     quantity and the ajax cart all behave exactly as they do up the page. Buy
     it now is only drawn when that button actually exists, which it does not on
     every product or in every market.
  */

  function initBuyBar() {
    if (document.querySelector('[data-ep-buybar]')) { return; }

    var form = document.querySelector('form.product-single__form');
    if (!form) { return; }

    var payment = form.querySelector('.payment-buttons');
    var realCart = form.querySelector('.add-to-cart') || form.querySelector('button[name="add"]');
    var meta = document.querySelector('.product-single__meta');
    var titleEl = meta && meta.querySelector('.product-single__title');
    if (!payment || !realCart || !titleEl) { return; }

    var priceEl = meta.querySelector('.product__price:not(.product__price--compare)')
      || meta.querySelector('.product-single__price');

    var thumbSrc = '';
    var firstImg = document.querySelector('.product-main-slide img, .product__main-photos img');
    if (firstImg) { thumbSrc = firstImg.currentSrc || firstImg.src || firstImg.getAttribute('data-src') || ''; }
    if (!thumbSrc) {
      var og = document.querySelector('meta[property="og:image"]');
      if (og) { thumbSrc = og.getAttribute('content') || ''; }
    }
    if (thumbSrc.indexOf('{width}') !== -1) { thumbSrc = thumbSrc.replace('{width}', '160'); }

    var bar = document.createElement('div');
    bar.className = 'ep-buybar';
    bar.setAttribute('data-ep-buybar', '');
    bar.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('div');
    inner.className = 'ep-buybar__inner';

    if (thumbSrc) {
      var thumb = document.createElement('span');
      thumb.className = 'ep-buybar__thumb';
      thumb.style.backgroundImage = 'url("' + thumbSrc.replace(/"/g, '%22') + '")';
      inner.appendChild(thumb);
    }

    var info = document.createElement('span');
    info.className = 'ep-buybar__info';
    var name = document.createElement('span');
    name.className = 'ep-buybar__title';
    name.textContent = (titleEl.textContent || '').trim();
    var price = document.createElement('span');
    price.className = 'ep-buybar__price';
    info.appendChild(name);
    info.appendChild(price);
    inner.appendChild(info);

    var actions = document.createElement('span');
    actions.className = 'ep-buybar__actions';

    var cartBtn = document.createElement('button');
    cartBtn.type = 'button';
    cartBtn.className = 'ep-buybar__btn ep-buybar__btn--cart';
    actions.appendChild(cartBtn);

    var nowBtn = null;
    inner.appendChild(actions);
    bar.appendChild(inner);
    document.body.appendChild(bar);

    /* Everything shown is mirrored from the real controls rather than worked out
       again, so a variant change, a sold out variant or a different button
       label all follow along on their own. */
    function realNow() {
      return document.querySelector('.shopify-payment-button__button');
    }

    function syncNow() {
      var target = realNow();
      if (target && !nowBtn) {
        nowBtn = document.createElement('button');
        nowBtn.type = 'button';
        nowBtn.className = 'ep-buybar__btn ep-buybar__btn--now';
        nowBtn.textContent = 'Buy it now';
        nowBtn.addEventListener('click', function () {
          var live = realNow();
          if (live) { live.click(); }
        });
        actions.appendChild(nowBtn);
      }
      if (nowBtn) {
        var gone = !target;
        nowBtn.style.display = gone ? 'none' : '';
        nowBtn.disabled = !!(target && target.disabled);
      }
    }

    function syncPrice() {
      if (!priceEl) { return; }
      price.textContent = (priceEl.textContent || '').trim();
    }

    function syncCart() {
      var label = realCart.querySelector('span:not(.icon__fallback-text)');
      var text = ((label ? label.textContent : realCart.textContent) || '').trim();
      cartBtn.textContent = text || 'Add to cart';
      cartBtn.disabled = !!realCart.disabled;
      bar.classList.toggle('ep-buybar--disabled', !!realCart.disabled);
    }

    syncPrice();
    syncCart();
    syncNow();

    if (window.MutationObserver) {
      if (priceEl) {
        new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
      }
      new MutationObserver(syncCart).observe(realCart, {
        childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class']
      });
      /* The dynamic checkout button is drawn by Shopify after the rest of the
         page, so watch for it rather than deciding once and being wrong. */
      new MutationObserver(syncNow).observe(payment, { childList: true, subtree: true });
    }

    form.addEventListener('change', function () {
      window.setTimeout(function () { syncPrice(); syncCart(); syncNow(); }, 60);
    });

    cartBtn.addEventListener('click', function () {
      realCart.click();
      window.setTimeout(function () {
        var error = form.querySelector('.product__policies--error, .form-error, .errors');
        if (error) { error.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }, 120);
    });

    /* ------------------------------------------------------------- visibility */

    var buyInView = false;

    function docHeight() {
      var b = document.body, e = document.documentElement;
      return Math.max(b.scrollHeight, b.offsetHeight, e.clientHeight, e.scrollHeight, e.offsetHeight);
    }

    function setShown(shown) {
      if (shown === bar.classList.contains('ep-buybar--in')) { return; }
      bar.classList.toggle('ep-buybar--in', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
    }

    function evaluate() {
      var vh = window.innerHeight || 0;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      /* As soon as the page moves at all, not after some arbitrary distance.
         The reason for hiding it at rest was that it covered the price on the
         opening screen; once the shopper has started scrolling that objection
         is gone, and every screen between there and the buy area is a screen
         with no way to buy on it. 60px is just enough to not react to a stray
         touch or the elastic bounce at the top of the page. */
      var scrolled = y > 60;

      /* Off again before the footer, so it is never the last thing on the page
         and never covers the end of it. */
      var nearBottom = (y + vh) > (docHeight() - 200);

      setShown(scrolled && !nearBottom && !buyInView);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; evaluate(); });
    }

    if (window.IntersectionObserver) {
      /* The bottom margin is negative by roughly the height of the bar, so the
         real buy area counts as "in view" a moment before it would otherwise
         slide underneath the bar. Without it the two cross over and the real
         buttons spend a second hidden behind the sticky ones. */
      new IntersectionObserver(function (entries) {
        buyInView = entries[0].isIntersecting;
        evaluate();
      }, { threshold: 0, rootMargin: '0px 0px -96px 0px' }).observe(payment);
    } else {
      buyInView = false;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  }

  /* ------------------------------------------------------------------- Boot */

  patchPhotoSwipe();
  initTapToZoom();

  function boot() {
    initSideNav();
    initDescription();
    initBuyBar();
    initPersonalisation();
  }

  /* Boot is deliberately run more than once.

     Two things on this store re-render the meta column after our first pass:
     the page-speed app, which restores its own copy of the markup, and the
     options app, which injects into the form on its own schedule. When either
     wins the race, everything we moved snaps back to the server order and the
     ticks, chips and description stay hidden at the foot of the page. It is a
     race, so it showed up intermittently rather than every time.

     Each init above is now a no-op once its block is placed, so re-running is
     free. We re-run on the usual events, on a short schedule, and whenever the
     product column is rebuilt underneath us, for the first ten seconds. */

  var settleUntil = 0;

  function startWatching() {
    settleUntil = Date.now() + 10000;
    boot();

    [200, 600, 1200, 2500, 4000, 7000].forEach(function (ms) {
      window.setTimeout(boot, ms);
    });

    var section = document.querySelector('.product-section') || document.body;
    if (!section || !window.MutationObserver) { return; }

    var pending = 0;
    var observer = new MutationObserver(function () {
      if (pending) { return; }
      pending = window.setTimeout(function () {
        pending = 0;
        if (Date.now() > settleUntil) { observer.disconnect(); return; }
        boot();
      }, 120);
    });
    observer.observe(section, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 10500);
  }

  /* The section loads this file after its own markup, so by the time it runs the
     column is already parsed and everything can be put in its final place before
     the browser paints. Waiting for DOMContentLoaded here — as this did — meant
     waiting until the whole document was parsed, which is after the first paint,
     and the reshuffle was visible on every load.

     The other two branches remain for the cases where that is not true: a quick
     view, a section re-render from the theme editor, or the file being pulled in
     from somewhere else. */
  if (document.querySelector('.product-single__meta')) {
    startWatching();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWatching);
  } else {
    startWatching();
  }

  window.addEventListener('load', boot);
})();
